import { FGDateInput, IFGDateInputProps } from "nsitools-react";
import * as React from "react";

export interface IFGSRSHDateMaskInputProps extends IFGDateInputProps {}

export const FGSRSHDateMaskInput: React.FunctionComponent<IFGDateInputProps> = ({ ...dateProps }) => {
  const maxDate = React.useMemo(() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() + 5);
    return d;
  }, []);

  return (
    <FGDateInput
      {...dateProps}
      minDate={new Date(1900, 1, 1)}
      maxDate={dateProps.maxDate ?? maxDate}
      //showPlaceholder={dateProps.readonly ? showPlaceholder : false}
      //placeholder={placeholder}
    />
  );
};
